import { RouteRecordRaw } from 'vue-router';
import { route } from '@/router/utils'
import { allPermissions } from '@access/index'
import { accessPermission } from '@access/permissions'

const {
  STAFF: {
    CLIENT: {
      CREATE,
      VIEW_LIST,
      EDIT,
    },
  },
} = allPermissions

const reportsList = () => import('./views/List.vue')

export const REPORTS_LIST_PAGE_NAME = 'cabinet:reports-list'

// URLs
export const REPORTS_LIST_PAGE_URL = ''

export function createRoutes(): typeof RouteRecordRaw[] {
  return [
    route(REPORTS_LIST_PAGE_URL, reportsList, REPORTS_LIST_PAGE_NAME, {
      meta: {
        breadcrumb: 'reports',
        ...accessPermission(VIEW_LIST),
      }
    }),
  ]
}
